import React, { Component } from "react";

import Icon from "../icon";

export default class Ratings extends Component {
  render(){
    if (!this.props.ratings) return;
    const ratings = [];
    for (let i = 0; i < this.props.ratings; i++) {
      ratings.push(<Icon style={{ color: "#FFC125", fill: "#FFC125" }} icon="Star" />)
    }
    return (
      <div className="flex gap-1">
        {
          ratings.map(rating => { return rating })
        }
      </div>
    )
  }
}